import { Redirect } from 'react-router-dom';
import LoaderPage from '../Components/Common/Loader';
import RecordInteraction from '../Components/RecordInteraction/RecordInteraction';
import ViewResults from '../Components/ViewResults/ViewResults';
import RedirectPageLogic from '../Components/RedirectPage/RedirectPage.logic';
import { useShouldShowNewRolePlayChanges } from 'features/realplays/RealPlaysHook';
import OldViewResults from '../Components/ViewResults/OldViewResults';
const PublicInteractiveRoleplay = () => {
  const { token, isLoading, showResults } = RedirectPageLogic();
  const { active: showNewChanges } = useShouldShowNewRolePlayChanges();

  if (!token) return <Redirect to="/" />;
  if (isLoading) return <LoaderPage />;
  return showResults ? <>
    {showNewChanges ? (<ViewResults />) : (<OldViewResults />)}
  </> : <RecordInteraction />;
};

export default PublicInteractiveRoleplay;
